<template>
  <div id="browse-marketplace">
    <div>
      <v-container class="content-wrapper" fluid>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12"></v-col>
          <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
            <v-select
              v-model="selectedCatalogue"
              :items="catalogueOptions"
              outlined
              hide-details
              background-color="#fafbff"
              class="custom-select"
              @change="navigateToCatalogue"
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <router-view></router-view>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Marketplace',

  data() {
    return {
      selectedCatalogue: 'Browse the Catalogue of Services',
      catalogueOptions: [
        'Browse the Catalogue of Services',
        'Browse the Catalogue of Providers',
        'Browse the Catalogue of Equipment',
        'Browse the Catalogue of Patents',
        'Browse the Catalogue of Hosting Institutions',
      ],
    };
  },

  watch: {
    '$route.query.selectedCatalogue'(newValue) {
      if (newValue) {
        this.selectedCatalogue = newValue;
      }
    },
  },

  mounted() {
    if (this.$route.query.selectedCatalogue) {
      this.selectedCatalogue = this.$route.query.selectedCatalogue;
    }
  },

  methods: {
    navigateToCatalogue() {
      let routePath = '';

      switch (this.selectedCatalogue) {
        case 'Browse the Catalogue of Services':
          routePath = '/marketplace/services';
          break;
        case 'Browse the Catalogue of Providers':
          routePath = '/marketplace/providers';
          break;
        case 'Browse the Catalogue of Equipment':
          routePath = '/marketplace/equipment';
          break;
        case 'Browse the Catalogue of Patents':
          routePath = '/marketplace/patents';
          break;
        case 'Browse the Catalogue of Hosting Institutions':
          routePath = '/marketplace/hosting-institutions';
          break;
        default:
          routePath = '/marketplace';
      }

      this.$router.push({
        path: routePath,
        query: {
          selectedCatalogue: this.selectedCatalogue,
        },
      });
    },
  },
};
</script>
